import { all, takeEvery, takeLatest } from "redux-saga/effects";
import {
  PAYROLL_CALCULATE_BULLETIN_REQUEST,
  PAYROLL_DELETE_RESOURCE_REQUEST,
  PAYROLL_FETCH_BULLETIN_LINES_REQUEST,
  PAYROLL_FETCH_RESOURCE_REQUEST,
  PAYROLL_SAVE_RESOURCE_REQUEST
} from "../../actions/payrollActions";
import {
  payrollCalculateBulletinSaga,
  payrollDeleteResourceSaga,
  payrollFetchBulletinLinesSaga,
  payrollFetchResourceSaga,
  payrollSaveResourceSaga
} from "../../sagas/payrollSaga";

import {
  CREATE_TIMESHEET_REQUEST, DELETE_TIMESHEET_DAY_REQUEST, DELETE_TIMESHEET_REQUEST, FETCH_TIMESHEET_DAYS_REQUEST,
  FETCH_TIMESHEETS_REQUEST,
  GET_TIMESHEET_REQUEST,
  UPDATE_TIMESHEET_REQUEST, UPSERT_TIMESHEET_DAY_REQUEST
} from "../../actions/timesheetActions";
import {
  createTimesheetSaga, deleteTimesheetDaySaga,
  deleteTimesheetSaga, fetchTimesheetDaysSaga, fetchTimesheetsSaga,
  getTimesheetSaga,
  updateTimesheetSaga, upsertTimesheetDaySaga
} from "../../sagas/timesheetSaga";

import {
  GET_CALENDAR_SETTINGS_REQUEST,
  GET_WORKDAYS_CONFIG_REQUEST,
  UPDATE_CALENDAR_SETTINGS_REQUEST,
  UPDATE_WORKDAYS_CONFIG_REQUEST
} from "../../actions/workDaysActions";
import {
  getCalendarSettingsSaga,
  getWorkdaysConfigSaga,
  updateCalendarSettingsSaga,
  updateWorkdaysConfigSaga,
} from "../../sagas/workDaysSaga";

import {
  ADMIN_NOTE_FRAIS_DECISION_REQUEST,
  CREATE_NOTE_FRAIS_REQUEST_REQUEST, GET_ADMIN_NOTE_FRAIS_HISTORY_REQUEST,
  GET_ADMIN_NOTE_FRAIS_INBOX_REQUEST, GET_MANAGER_NOTE_FRAIS_HISTORY_REQUEST,
  GET_MANAGER_NOTE_FRAIS_INBOX_REQUEST,
  GET_MY_NOTE_FRAIS_REQUESTS_REQUEST, GET_NOTE_FRAIS_BY_ORDRE_MISSION_REQUEST,
  GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_REQUEST,
  MANAGER_NOTE_FRAIS_DECISION_REQUEST,
  MARQUER_NOTE_FRAIS_REMBOURSE_REQUEST
} from "../../actions/noteDeFraisRequestActions";
import {
  adminNoteDeFraisDecisionSaga,
  createNoteDeFraisRequestSaga, getAdminNoteDeFraisHistorySaga,
  getAdminNoteDeFraisInboxSaga, getManagerNoteDeFraisHistorySaga,
  getManagerNoteDeFraisInboxSaga,
  getMyNoteDeFraisRequestsSaga, getNoteDeFraisByOrdreMissionSaga,
  getNoteDeFraisEnAttenteRemboursementSaga,
  managerNoteDeFraisDecisionSaga,
  marquerNoteDeFraisRembourseeSaga
} from "../../sagas/noteDeFraisRequestSaga";

import {
  CANCEL_LEAVE_REQUEST_REQUEST,
  CHECK_BALANCE_REQUEST,
  GET_ALL_COMPANY_SOLDES_REQUEST,
  GET_ALL_MOVEMENTS_REQUEST,
  UPDATE_SOLDE_REQUEST,
  GET_USER_MOVEMENTS_REQUEST,
  GET_USER_SOLDES_REQUEST, EXPORT_SOLDES_EXCEL_REQUEST, IMPORT_SOLDES_EXCEL_REQUEST,
} from "../../actions/leaveBalanceActions";
import {
  cancelLeaveRequestSaga,
  checkBalanceSaga,
  getUserSoldesSaga,
  getAllCompanySoldesSaga,
  exportSoldesExcelSaga,
  importSoldesExcelSaga,
  updateSoldeSaga,
  getUserMovementsSaga,
  getAllMovementsSaga,
} from "../../sagas/leaveBalanceSaga";

import {
  ADMIN_AVANCE_DECISION_REQUEST,
  CREATE_AVANCE_REQUEST_REQUEST,
  ENREGISTRER_REMBOURSEMENT_REQUEST, GET_ADMIN_AVANCE_HISTORY_REQUEST,
  GET_ADMIN_AVANCE_INBOX_REQUEST,
  GET_MANAGER_AVANCE_INBOX_REQUEST,
  GET_MY_AVANCE_REQUESTS_REQUEST,
  GET_MY_AVANCES_EN_COURS_REQUEST,
  MANAGER_AVANCE_DECISION_REQUEST, REMBOURSEMENT_ANTICIPE_REQUEST,
  GET_MANAGER_AVANCE_HISTORY_REQUEST,
  EXPORT_AVANCE_REQUESTS_EXCEL_REQUEST
} from "../../actions/avanceRequestActions";
import {
  adminAvanceDecisionSaga,
  createAvanceRequestSaga, enregistrerRemboursementSaga, getAdminAvanceHistorySaga, getAdminAvanceInboxSaga,
  getManagerAvanceInboxSaga,
  getMyAvanceRequestsSaga,
  getMyAvancesEnCoursSaga, managerAvanceDecisionSaga, remboursementAnticipeSaga, getManagerAvanceHistorySaga,
  exportAvanceRequestsExcelSaga
} from "../../sagas/avanceRequestsSaga";

import {
  ADMIN_MISSION_DECISION_REQUEST,
  CANCEL_MISSION_REQUEST_REQUEST, CREATE_MISSION_REQUEST_FOR_COLLAB_REQUEST,
  CREATE_MISSION_REQUEST_REQUEST, DUPLICATE_MISSION_REQUEST_REQUEST, GET_ADMIN_MISSION_HISTORY_REQUEST,
  GET_ADMIN_MISSION_INBOX_REQUEST, GET_ALL_MISSION_REQUESTS_REQUEST,
  GET_MANAGER_MISSION_HISTORY_REQUEST,
  GET_MANAGER_MISSION_INBOX_REQUEST,
  GET_MISSION_REQUEST_REQUEST,
  GET_MY_CREATED_MISSION_REQUESTS_REQUEST,
  GET_MY_MISSION_REQUESTS_REQUEST,
  MANAGER_MISSION_DECISION_REQUEST
} from "../../actions/missionRequestActions";
import {
  adminMissionDecisionSaga,
  cancelMissionRequestSaga, createMissionRequestForCollabSaga,
  createMissionRequestSaga, duplicateMissionRequestSaga,
  getAdminMissionHistorySaga,
  getAdminMissionInboxSaga, getAllMissionRequestsSaga,
  getManagerMissionHistorySaga,
  getManagerMissionInboxSaga,
  getMissionRequestSaga,
  getMyCreatedMissionRequestsSaga,
  getMyMissionRequestsSaga,
  managerMissionDecisionSaga
} from "../../sagas/missionRequestSaga";

import {
  FETCH_PARAM_AVANTAGES_REQUEST,
  CREATE_AV_CAT_REQUEST,
  UPDATE_AV_CAT_REQUEST,
  DELETE_AV_CAT_REQUEST,
  CREATE_AV_REGLE_REQUEST,
  UPDATE_AV_REGLE_REQUEST,
  DELETE_AV_REGLE_REQUEST,
  CREATE_AVANTAGE_REQUEST,
  UPDATE_AVANTAGE_REQUEST,
  DELETE_AVANTAGE_REQUEST,
} from "../../actions/paramAvantagesActions";
import {
  fetchParamAvantagesSaga,
  createAvCatSaga,
  updateAvCatSaga,
  deleteAvCatSaga,
  createAvRegleSaga,
  updateAvRegleSaga,
  deleteAvRegleSaga,
  createAvantageSaga,
  updateAvantageSaga,
  deleteAvantageSaga,
} from "../../sagas/paramAvantagesSaga";

import {
  GET_WORKFLOW_LEVELS_REQUEST, SAVE_WORKFLOW_LEVELS_REQUEST,
} from "../../actions/workflowValidationActions";
import {
  getWorkflowLevelsSaga, saveWorkflowLevelsSaga
} from "../../sagas/workflowValidationSaga";

import {
  CREATE_ABSENCE_TYPE_REQUEST, CREATE_ACQ_RULE_REQUEST,
  CREATE_JUSTIF_RULE_REQUEST, DELETE_ABSENCE_TYPE_REQUEST, DELETE_ACQ_RULE_REQUEST, DELETE_JUSTIF_RULE_REQUEST,
  FETCH_PARAM_CONGES_REQUEST,
  UPDATE_ABSENCE_TYPE_REQUEST, UPDATE_ACQ_RULE_REQUEST, UPDATE_JUSTIF_RULE_REQUEST,
  INIT_STANDARD_CONFIG_REQUEST
} from "../../actions/paramCongesActions";
import {
  createAbsenceTypeSaga, createAcqRuleSaga, createJustifRuleSaga,
  deleteAbsenceTypeSaga, deleteAcqRuleSaga, deleteJustifRuleSaga,
  fetchParamCongesSaga,
  updateAbsenceTypeSaga, updateAcqRuleSaga, updateJustifRuleSaga, initStandardConfigSaga
} from "../../sagas/paramCongesSaga";

import { FETCH_MES_AVANTAGES_REQUEST } from "../../actions/mesAvantagesActions";
import { fetchMesAvantagesSaga } from "../../sagas/mesAvantagesSaga";

import {
  ADMIN_DECISION_REQUEST,
  CREATE_LEAVE_REQUEST_REQUEST,
  GET_ADMIN_INBOX_REQUEST, GET_MANAGER_INBOX_REQUEST,
  GET_MANAGER_HISTORY_REQUEST,
  GET_MANAGER_TEAM_LEAVES_REQUEST,
  GET_MY_LEAVE_REQUESTS_REQUEST, MANAGER_DECISION_REQUEST,
  MANAGER_DELEGATE_TO_ADMIN_REQUEST,
  POSTPONE_LEAVE_REQUEST_REQUEST,
  UPLOAD_LEAVE_JUSTIFICATIFS_REQUEST,
  GET_ALL_LEAVE_REQUESTS_REQUEST,
  EXPORT_LEAVE_REQUESTS_EXCEL_REQUEST,
} from "../../actions/leaveRequestsActions";
import {
  adminDecisionSaga,
  createLeaveRequestSaga,
  getAdminInboxSaga,
  getManagerInboxSaga,
  getManagerHistorySaga,
  getManagerTeamLeavesSaga,
  getMyLeaveRequestsSaga,
  managerDecisionSaga,
  postponeLeaveRequestSaga,
  uploadLeaveJustificatifsSaga,
  getAllLeaveRequestsSaga,
  exportLeaveRequestsExcelSaga, managerDelegateToAdminSaga,
} from "../../sagas/leaveRequestsSaga";

import {
  CREATE_NOTE_DE_FRAIS_REQUEST, DELETE_NOTE_DE_FRAIS_REQUEST, FETCH_NOTE_DE_FRAIS_ACTIFS_REQUEST,
  FETCH_NOTE_DE_FRAIS_BY_ID_REQUEST,
  FETCH_NOTE_DE_FRAIS_REQUEST, UPDATE_NOTE_DE_FRAIS_REQUEST
} from "../../actions/noteDeFraisActions";
import {
  createNoteDeFraisSaga, deleteNoteDeFraisSaga, fetchNoteDeFraisActifsSaga,
  fetchNoteDeFraisByIdSaga,
  fetchNoteDeFraisSaga,
  updateNoteDeFraisSaga
} from "../../sagas/noteDeFraisSaga";

import {
  CREATE_ORDRE_MISSION_REQUEST, DELETE_ORDRE_MISSION_REQUEST, FETCH_ORDRE_MISSION_ACTIFS_REQUEST,
  FETCH_ORDRE_MISSION_BY_ID_REQUEST, FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST, FETCH_ORDRE_MISSION_EN_COURS_REQUEST,
  FETCH_ORDRE_MISSION_REQUEST, UPDATE_ORDRE_MISSION_REQUEST
} from "../../actions/ordreMissionActions";
import {
  createOrdreMissionSaga,
  deleteOrdreMissionSaga,
  fetchOrdreMissionActifsSaga, fetchOrdreMissionByIdSaga,
  fetchOrdreMissionByPeriodSaga,
  fetchOrdreMissionEnCoursSaga,
  fetchOrdreMissionSaga, updateOrdreMissionSaga
} from "../../sagas/ordreMissionSaga";

import {
  CREATE_ETAPE_REQUEST,
  CREATE_OFFBOARDING_REQUEST, DELETE_ETAPE_REQUEST, DELETE_OFFBOARDING_REQUEST, FETCH_ETAPES_REQUEST,
  FETCH_OFFBOARDINGS_REQUEST,
  GET_OFFBOARDING_REQUEST, UPDATE_ETAPE_REQUEST, UPDATE_OFFBOARDING_REQUEST
} from "../../actions/offboardingActions";
import {
  createOffboardingSaga,
  createEtapeSaga,
  deleteOffboardingSaga,
  deleteEtapeSaga,
  fetchOffboardingsSaga,
  fetchEtapesSaga,
  getOffboardingSaga,
  updateOffboardingSaga,
  updateEtapeSaga,
} from "../../sagas/offboardingSaga";

import {
  CREATE_AVANCE_REQUEST, DELETE_AVANCE_REQUEST, FETCH_AVANCE_ACTIFS_REQUEST,
  FETCH_AVANCE_BY_ID_REQUEST,
  FETCH_AVANCE_REQUEST,
  UPDATE_AVANCE_REQUEST
} from "../../actions/avanceActions";
import {
  createAvanceSaga,
  deleteAvanceSaga, fetchAvanceActifsSaga,
  fetchAvanceByIdSaga,
  fetchAvanceSaga,
  updateAvanceSaga
} from "../../sagas/avanceSaga";

import {
  ADMIN_ATTESTATION_DECISION_REQUEST,
  CREATE_ATTESTATION_REQUEST,
  CREATE_ATTESTATION_REQUEST_REQUEST,
  DELETE_ATTESTATION_REQUEST,
  DOWNLOAD_ATTESTATION_PDF_REQUEST,
  DOWNLOAD_ATTESTATION_REQUEST_PDF_REQUEST,
  FETCH_ATTESTATIONS_REQUEST,
  GET_ADMIN_ATTESTATION_INBOX_REQUEST,
  GET_MANAGER_ATTESTATION_INBOX_REQUEST,
  GET_MY_ATTESTATION_REQUESTS_REQUEST,
  MANAGER_ATTESTATION_DECISION_REQUEST,
  UPDATE_ATTESTATION_REQUEST,
} from "../../actions/attestationsActions";
import {
  adminAttestationDecisionSaga,
  createAttestationRequestSaga,
  createAttestationSaga,
  deleteAttestationSaga,
  downloadAttestationPdfSaga,
  downloadAttestationRequestPdfSaga,
  fetchAttestationsSaga,
  getAdminAttestationInboxSaga,
  getManagerAttestationInboxSaga,
  getMyAttestationRequestsSaga,
  managerAttestationDecisionSaga,
  updateAttestationSaga,
} from "../../sagas/attestationsSaga";

import {
  FETCH_TIMESHEET_MANAGER_INBOX_REQUEST,
  FETCH_TIMESHEET_ADMIN_INBOX_REQUEST,
  TIMESHEET_MANAGER_DECISION_REQUEST,
  TIMESHEET_ADMIN_DECISION_REQUEST,
} from "../../actions/timesheetWorkflowActions";
import {
  fetchManagerInboxSaga,
  fetchAdminInboxSaga,
  timesheetManagerDecisionSaga,
  timesheetAdminDecisionSaga,
} from "../../sagas/timesheetWorkflowSaga";

import workflowSaga from "../../sagas/workflowSagas";
import sectionSaga from "../../sagas/sectionSagas";
import changeRequestSaga from "../../sagas/changeRequestSagas";

export default function* grhRootSaga() {
  yield takeEvery(PAYROLL_FETCH_RESOURCE_REQUEST, payrollFetchResourceSaga);
  yield takeLatest(PAYROLL_SAVE_RESOURCE_REQUEST, payrollSaveResourceSaga);
  yield takeLatest(PAYROLL_DELETE_RESOURCE_REQUEST, payrollDeleteResourceSaga);
  yield takeLatest(PAYROLL_CALCULATE_BULLETIN_REQUEST, payrollCalculateBulletinSaga);
  yield takeLatest(PAYROLL_FETCH_BULLETIN_LINES_REQUEST, payrollFetchBulletinLinesSaga);

  yield takeLatest(FETCH_TIMESHEETS_REQUEST, fetchTimesheetsSaga);
  yield takeLatest(GET_TIMESHEET_REQUEST, getTimesheetSaga);
  yield takeLatest(CREATE_TIMESHEET_REQUEST, createTimesheetSaga);
  yield takeLatest(UPDATE_TIMESHEET_REQUEST, updateTimesheetSaga);
  yield takeLatest(DELETE_TIMESHEET_REQUEST, deleteTimesheetSaga);
  yield takeLatest(FETCH_TIMESHEET_DAYS_REQUEST, fetchTimesheetDaysSaga);
  yield takeEvery(UPSERT_TIMESHEET_DAY_REQUEST, upsertTimesheetDaySaga);
  yield takeLatest(DELETE_TIMESHEET_DAY_REQUEST, deleteTimesheetDaySaga);

  yield all([
    takeLatest(GET_CALENDAR_SETTINGS_REQUEST, getCalendarSettingsSaga),
    takeLatest(GET_WORKDAYS_CONFIG_REQUEST, getWorkdaysConfigSaga),
    takeLatest(UPDATE_CALENDAR_SETTINGS_REQUEST, updateCalendarSettingsSaga),
    takeLatest(UPDATE_WORKDAYS_CONFIG_REQUEST, updateWorkdaysConfigSaga),
  ]);

  yield takeLatest(GET_MY_NOTE_FRAIS_REQUESTS_REQUEST, getMyNoteDeFraisRequestsSaga);
  yield takeLatest(CREATE_NOTE_FRAIS_REQUEST_REQUEST, createNoteDeFraisRequestSaga);
  yield takeLatest(GET_MANAGER_NOTE_FRAIS_INBOX_REQUEST, getManagerNoteDeFraisInboxSaga);
  yield takeLatest(MANAGER_NOTE_FRAIS_DECISION_REQUEST, managerNoteDeFraisDecisionSaga);
  yield takeLatest(GET_ADMIN_NOTE_FRAIS_INBOX_REQUEST, getAdminNoteDeFraisInboxSaga);
  yield takeLatest(ADMIN_NOTE_FRAIS_DECISION_REQUEST, adminNoteDeFraisDecisionSaga);
  yield takeLatest(MARQUER_NOTE_FRAIS_REMBOURSE_REQUEST, marquerNoteDeFraisRembourseeSaga);
  yield takeLatest(GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_REQUEST, getNoteDeFraisEnAttenteRemboursementSaga);
  yield takeLatest(GET_NOTE_FRAIS_BY_ORDRE_MISSION_REQUEST, getNoteDeFraisByOrdreMissionSaga);
  yield takeLatest(GET_MANAGER_NOTE_FRAIS_HISTORY_REQUEST, getManagerNoteDeFraisHistorySaga);
  yield takeLatest(GET_ADMIN_NOTE_FRAIS_HISTORY_REQUEST, getAdminNoteDeFraisHistorySaga);
  yield takeLatest(INIT_STANDARD_CONFIG_REQUEST, initStandardConfigSaga);


  yield takeLatest(CHECK_BALANCE_REQUEST, checkBalanceSaga);
  yield takeLatest(GET_ALL_COMPANY_SOLDES_REQUEST, getAllCompanySoldesSaga);
  yield takeLatest(GET_ALL_MOVEMENTS_REQUEST, getAllMovementsSaga);
  yield takeLatest(GET_USER_SOLDES_REQUEST, getUserSoldesSaga);
  yield takeLatest(GET_USER_MOVEMENTS_REQUEST, getUserMovementsSaga);
  yield takeLatest(EXPORT_SOLDES_EXCEL_REQUEST, exportSoldesExcelSaga);
  yield takeLatest(IMPORT_SOLDES_EXCEL_REQUEST, importSoldesExcelSaga);
  yield takeLatest(UPDATE_SOLDE_REQUEST, updateSoldeSaga);
  yield takeLatest(CANCEL_LEAVE_REQUEST_REQUEST, cancelLeaveRequestSaga);

  yield takeLatest(GET_MY_AVANCE_REQUESTS_REQUEST, getMyAvanceRequestsSaga);
  yield takeLatest(GET_MY_AVANCES_EN_COURS_REQUEST, getMyAvancesEnCoursSaga);
  yield takeLatest(CREATE_AVANCE_REQUEST_REQUEST, createAvanceRequestSaga);
  yield takeLatest(GET_MANAGER_AVANCE_INBOX_REQUEST, getManagerAvanceInboxSaga);
  yield takeLatest(MANAGER_AVANCE_DECISION_REQUEST, managerAvanceDecisionSaga);
  yield takeLatest(GET_ADMIN_AVANCE_INBOX_REQUEST, getAdminAvanceInboxSaga);
  yield takeLatest(ADMIN_AVANCE_DECISION_REQUEST, adminAvanceDecisionSaga);
  yield takeLatest(EXPORT_AVANCE_REQUESTS_EXCEL_REQUEST, exportAvanceRequestsExcelSaga);
  yield takeLatest(ENREGISTRER_REMBOURSEMENT_REQUEST, enregistrerRemboursementSaga);
  yield takeLatest(REMBOURSEMENT_ANTICIPE_REQUEST, remboursementAnticipeSaga);

  yield all([
    takeLatest(GET_MY_MISSION_REQUESTS_REQUEST, getMyMissionRequestsSaga),
    takeLatest(GET_MISSION_REQUEST_REQUEST, getMissionRequestSaga),
    takeLatest(CREATE_MISSION_REQUEST_REQUEST, createMissionRequestSaga),
    takeLatest(CANCEL_MISSION_REQUEST_REQUEST, cancelMissionRequestSaga),
    takeLatest(GET_MANAGER_MISSION_INBOX_REQUEST, getManagerMissionInboxSaga),
    takeLatest(MANAGER_MISSION_DECISION_REQUEST, managerMissionDecisionSaga),
    takeLatest(GET_MANAGER_MISSION_HISTORY_REQUEST, getManagerMissionHistorySaga),
    takeLatest(GET_ADMIN_MISSION_INBOX_REQUEST, getAdminMissionInboxSaga),
    takeLatest(ADMIN_MISSION_DECISION_REQUEST, adminMissionDecisionSaga),
    takeLatest(GET_ADMIN_MISSION_HISTORY_REQUEST, getAdminMissionHistorySaga),
    takeLatest(GET_ALL_MISSION_REQUESTS_REQUEST, getAllMissionRequestsSaga),
  ]);

  yield takeLatest(GET_WORKDAYS_CONFIG_REQUEST, getWorkdaysConfigSaga);
  yield takeLatest(UPDATE_WORKDAYS_CONFIG_REQUEST, updateWorkdaysConfigSaga);
  yield takeLatest(GET_CALENDAR_SETTINGS_REQUEST, getCalendarSettingsSaga);
  yield takeLatest(UPDATE_CALENDAR_SETTINGS_REQUEST, updateCalendarSettingsSaga);

  yield takeLatest(CREATE_MISSION_REQUEST_FOR_COLLAB_REQUEST, createMissionRequestForCollabSaga);

  yield takeLatest(FETCH_ATTESTATIONS_REQUEST, fetchAttestationsSaga);
  yield takeLatest(CREATE_ATTESTATION_REQUEST, createAttestationSaga);
  yield takeLatest(UPDATE_ATTESTATION_REQUEST, updateAttestationSaga);
  yield takeLatest(DELETE_ATTESTATION_REQUEST, deleteAttestationSaga);
  yield takeLatest(GET_MY_ATTESTATION_REQUESTS_REQUEST, getMyAttestationRequestsSaga);
  yield takeLatest(CREATE_ATTESTATION_REQUEST_REQUEST, createAttestationRequestSaga);
  yield takeLatest(GET_MANAGER_ATTESTATION_INBOX_REQUEST, getManagerAttestationInboxSaga);
  yield takeLatest(MANAGER_ATTESTATION_DECISION_REQUEST, managerAttestationDecisionSaga);
  yield takeLatest(GET_ADMIN_ATTESTATION_INBOX_REQUEST, getAdminAttestationInboxSaga);
  yield takeLatest(ADMIN_ATTESTATION_DECISION_REQUEST, adminAttestationDecisionSaga);
  yield takeLatest(DOWNLOAD_ATTESTATION_PDF_REQUEST, downloadAttestationPdfSaga);
  yield takeLatest(DOWNLOAD_ATTESTATION_REQUEST_PDF_REQUEST, downloadAttestationRequestPdfSaga);

  yield takeLatest(FETCH_PARAM_AVANTAGES_REQUEST, fetchParamAvantagesSaga);
  yield takeLatest(CREATE_AV_CAT_REQUEST, createAvCatSaga);
  yield takeLatest(UPDATE_AV_CAT_REQUEST, updateAvCatSaga);
  yield takeLatest(DELETE_AV_CAT_REQUEST, deleteAvCatSaga);
  yield takeLatest(CREATE_AV_REGLE_REQUEST, createAvRegleSaga);
  yield takeLatest(UPDATE_AV_REGLE_REQUEST, updateAvRegleSaga);
  yield takeLatest(DELETE_AV_REGLE_REQUEST, deleteAvRegleSaga);
  yield takeLatest(CREATE_AVANTAGE_REQUEST, createAvantageSaga);
  yield takeLatest(UPDATE_AVANTAGE_REQUEST, updateAvantageSaga);
  yield takeLatest(DELETE_AVANTAGE_REQUEST, deleteAvantageSaga);

  yield takeLatest(GET_WORKFLOW_LEVELS_REQUEST, getWorkflowLevelsSaga);
  yield takeLatest(SAVE_WORKFLOW_LEVELS_REQUEST, saveWorkflowLevelsSaga);

  yield takeLatest(FETCH_PARAM_CONGES_REQUEST, fetchParamCongesSaga);
  yield takeLatest(CREATE_ABSENCE_TYPE_REQUEST, createAbsenceTypeSaga);
  yield takeLatest(UPDATE_ABSENCE_TYPE_REQUEST, updateAbsenceTypeSaga);
  yield takeLatest(DELETE_ABSENCE_TYPE_REQUEST, deleteAbsenceTypeSaga);
  yield takeLatest(CREATE_ACQ_RULE_REQUEST, createAcqRuleSaga);
  yield takeLatest(UPDATE_ACQ_RULE_REQUEST, updateAcqRuleSaga);
  yield takeLatest(DELETE_ACQ_RULE_REQUEST, deleteAcqRuleSaga);
  yield takeLatest(FETCH_MES_AVANTAGES_REQUEST, fetchMesAvantagesSaga);
  yield takeLatest(CREATE_JUSTIF_RULE_REQUEST, createJustifRuleSaga);
  yield takeLatest(UPDATE_JUSTIF_RULE_REQUEST, updateJustifRuleSaga);
  yield takeLatest(DELETE_JUSTIF_RULE_REQUEST, deleteJustifRuleSaga);

  yield takeLatest(CREATE_LEAVE_REQUEST_REQUEST, createLeaveRequestSaga);
  yield takeLatest(GET_MY_LEAVE_REQUESTS_REQUEST, getMyLeaveRequestsSaga);
  yield takeLatest(GET_MANAGER_INBOX_REQUEST, getManagerInboxSaga);
  yield takeLatest(GET_MANAGER_HISTORY_REQUEST, getManagerHistorySaga);
  yield takeLatest(GET_MANAGER_TEAM_LEAVES_REQUEST, getManagerTeamLeavesSaga);
  yield takeLatest(MANAGER_DECISION_REQUEST, managerDecisionSaga);
  yield takeLatest(GET_ADMIN_INBOX_REQUEST, getAdminInboxSaga);
  yield takeLatest(MANAGER_DELEGATE_TO_ADMIN_REQUEST, managerDelegateToAdminSaga);
  yield takeLatest(ADMIN_DECISION_REQUEST, adminDecisionSaga);
  yield takeLatest(POSTPONE_LEAVE_REQUEST_REQUEST, postponeLeaveRequestSaga);

  yield takeLatest(FETCH_NOTE_DE_FRAIS_REQUEST, fetchNoteDeFraisSaga);
  yield takeLatest(FETCH_NOTE_DE_FRAIS_BY_ID_REQUEST, fetchNoteDeFraisByIdSaga);
  yield takeLatest(CREATE_NOTE_DE_FRAIS_REQUEST, createNoteDeFraisSaga);
  yield takeLatest(UPDATE_NOTE_DE_FRAIS_REQUEST, updateNoteDeFraisSaga);
  yield takeLatest(DELETE_NOTE_DE_FRAIS_REQUEST, deleteNoteDeFraisSaga);
  yield takeLatest(FETCH_NOTE_DE_FRAIS_ACTIFS_REQUEST, fetchNoteDeFraisActifsSaga);

  yield takeLatest(FETCH_ORDRE_MISSION_REQUEST, fetchOrdreMissionSaga);
  yield takeLatest(FETCH_ORDRE_MISSION_BY_ID_REQUEST, fetchOrdreMissionByIdSaga);
  yield takeLatest(CREATE_ORDRE_MISSION_REQUEST, createOrdreMissionSaga);
  yield takeLatest(UPDATE_ORDRE_MISSION_REQUEST, updateOrdreMissionSaga);
  yield takeLatest(DELETE_ORDRE_MISSION_REQUEST, deleteOrdreMissionSaga);
  yield takeLatest(FETCH_ORDRE_MISSION_ACTIFS_REQUEST, fetchOrdreMissionActifsSaga);
  yield takeLatest(FETCH_ORDRE_MISSION_EN_COURS_REQUEST, fetchOrdreMissionEnCoursSaga);
  yield takeLatest(FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST, fetchOrdreMissionByPeriodSaga);

  yield takeLatest(FETCH_OFFBOARDINGS_REQUEST, fetchOffboardingsSaga);
  yield takeLatest(GET_OFFBOARDING_REQUEST, getOffboardingSaga);
  yield takeLatest(CREATE_OFFBOARDING_REQUEST, createOffboardingSaga);
  yield takeLatest(UPDATE_OFFBOARDING_REQUEST, updateOffboardingSaga);
  yield takeLatest(DELETE_OFFBOARDING_REQUEST, deleteOffboardingSaga);
  yield takeLatest(FETCH_ETAPES_REQUEST, fetchEtapesSaga);
  yield takeLatest(CREATE_ETAPE_REQUEST, createEtapeSaga);
  yield takeLatest(UPDATE_ETAPE_REQUEST, updateEtapeSaga);
  yield takeLatest(DELETE_ETAPE_REQUEST, deleteEtapeSaga);

  yield takeLatest(FETCH_AVANCE_REQUEST, fetchAvanceSaga);
  yield takeLatest(FETCH_AVANCE_BY_ID_REQUEST, fetchAvanceByIdSaga);
  yield takeLatest(CREATE_AVANCE_REQUEST, createAvanceSaga);
  yield takeLatest(UPDATE_AVANCE_REQUEST, updateAvanceSaga);
  yield takeLatest(DELETE_AVANCE_REQUEST, deleteAvanceSaga);
  yield takeLatest(FETCH_AVANCE_ACTIFS_REQUEST, fetchAvanceActifsSaga);

  yield takeLatest(DUPLICATE_MISSION_REQUEST_REQUEST, duplicateMissionRequestSaga);

  yield takeLatest(FETCH_TIMESHEET_MANAGER_INBOX_REQUEST, fetchManagerInboxSaga);
  yield takeLatest(FETCH_TIMESHEET_ADMIN_INBOX_REQUEST, fetchAdminInboxSaga);
  yield takeLatest(TIMESHEET_MANAGER_DECISION_REQUEST, timesheetManagerDecisionSaga);
  yield takeLatest(TIMESHEET_ADMIN_DECISION_REQUEST, timesheetAdminDecisionSaga);

  yield takeLatest(GET_MY_CREATED_MISSION_REQUESTS_REQUEST, getMyCreatedMissionRequestsSaga);


      yield takeLatest(GET_ADMIN_AVANCE_HISTORY_REQUEST, getAdminAvanceHistorySaga);
  yield takeLatest(GET_MANAGER_AVANCE_HISTORY_REQUEST, getManagerAvanceHistorySaga);

  yield* workflowSaga();
  yield* sectionSaga();
  yield* changeRequestSaga();
}
